var _circle, _circle2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPyqSliderDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4863,
    cy: 44,
    r: 28,
    fill: "#303034"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5703,
    cy: 41.0834,
    r: 8.75,
    fill: "#3C45CD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2717 47.5616C34.7023 45.8279 35.6059 43.6042 35.6059 41.1544C35.6059 35.6517 31.1258 31.1666 25.6291 31.1666C20.1325 31.1666 15.6523 35.6517 15.6523 41.1544C15.6523 46.6571 20.1325 51.1422 25.6291 51.1422C28.0386 51.1422 30.2975 50.2753 32.0293 48.8054L39.7848 56.5695C39.9731 56.7579 40.199 56.8333 40.4249 56.8333C40.6508 56.8333 40.8766 56.7579 41.0649 56.5695C41.4037 56.2303 41.4037 55.6272 41.0649 55.288L33.2717 47.5616ZM25.5915 49.333C21.0737 49.333 17.4218 45.6771 17.4218 41.1544C17.4218 36.6316 21.0737 32.9757 25.5915 32.9757C30.1093 32.9757 33.7611 36.6316 33.7611 41.1544C33.7611 45.6771 30.1093 49.333 25.5915 49.333Z",
    fill: "#92A1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5728 5.78625L52.4038 17.4717",
    stroke: "#92A1FF",
    strokeWidth: 3.125,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5142 25.3485L56.49 27.2067",
    stroke: "#92A1FF",
    strokeWidth: 3.125,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4863 2L40.4865 12.3289",
    stroke: "#92A1FF",
    strokeWidth: 3.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyqSliderDark);
export default __webpack_public_path__ + "static/media/pyq_slider_dark.6e624685d959ce0e1c95071b21aaa8ab.svg";
export { ForwardRef as ReactComponent };